// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"Skeleton_skeleton__KQoiO","placeholderShimmer":"Skeleton_placeholderShimmer__9v5s_","darkSkeleton":"Skeleton_darkSkeleton__AAgD2"};